import initSearch from "./behaviour/search.js";
import { initBreadcrumb } from "./page/breadcrumb.js";
import initNavigation from "./navigation/navigation.js";
import buildAccordions from "./behaviour/accordion-builder.js";
import initAccordions from "./behaviour/accordion.js";
import initAlerts from "./behaviour/alerts.js";
import { initEssentialLinks } from "./behaviour/essential-links.js";
import initGridNavigation from "./modules/grid-navigation.js";
import initExamTrack from "./examtrack/examtrack-ui.js";
import initNewsFeed from "./behaviour/news-feed.js";
import initEventsFeed from "./behaviour/events-feed.js";
import initEvents from "./modules/events.js";
import transformVideos from "./behaviour/transform-videos.js";
import initVideoPlayer from "./behaviour/video-player.js";
import initContentRenderer from "./modules/content-renderer.js";
import initModals from "./behaviour/modal.js";
import initAtoZ from "./modules/atoz.js";
import initContactForms from './behaviour/contact-form.js';

document.addEventListener("DOMContentLoaded", () => {
  console.log("student-zone loaded");

  const doc = document;

  /* Utility UI */
  initSearch();

  initNavigation();

  if (doc.querySelector(".sz-breadcrumb")) {
    initBreadcrumb();
  }

  if (doc.querySelector("#sz-alert-source")) {
    initAlerts();
  }

  if (doc.querySelector('[data-module="essential-links"]')) {
    initEssentialLinks();
  }

  initExamTrack();
  initNewsFeed();
  initEventsFeed();
  initContentRenderer();
  transformVideos(document);

  if (doc.querySelector("[data-accordion]")) {
    buildAccordions();
    initAccordions();
  }
  initVideoPlayer();

  initModals();
  initContactForms();
  initGridNavigation();
  
  if (doc.querySelector('[data-module="atoz"]')) {
    initAtoZ();
  }
});
